export const defaultNumberInputIcons = {
    plusButtonIconName: 'plus-circle',
    minusButtonIconName: 'minus-circle',
    dropdownButtonIconName: 'chevron-down'
};
